import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetFanLetterById } from '../../../domains/bettie/ui/hooks/useGetFanLetterById';
import { useGenerateFanLetter } from '../../../domains/bettie/ui/hooks/useGenerateFanLetter';
import { useGetBettieBalances } from '../../../domains/bettie/ui/hooks/useGetBettieBalances';

const HEART_COUNT_PER_LETTER = 3;

export const useFanLetterDetail = () => {
  const { letterId } = useParams();
  const [isError, setIsError] = useState(false);

  const { data: fanLetter, isLoading: isLoadingFanLetter } = useGetFanLetterById({
    letterId: letterId as string
  });
  const { mutateAsync: generateFanLetter, isLoading: isLoadingGenerate } = useGenerateFanLetter({
    letterId: letterId as string
  });
  const { data: bettieBalances } = useGetBettieBalances();

  const currentHearts = bettieBalances?.bettiePoint?.balance ?? 0;
  const hasEnoughHearts = currentHearts >= HEART_COUNT_PER_LETTER;

  const handleOpenFanLetter = async () => {
    if (!letterId) return;
    if (!hasEnoughHearts) {
      setIsError(true);
      return;
    }

    try {
      const response = await generateFanLetter({ id: letterId });

      if (!response.fanLetter) {
        throw new Error('Failed to read fan letter');
      }
    } catch (error) {
      // biome-ignore lint: error is handled
      console.error(error);
    }
  };

  return {
    fanLetter,
    handleOpenFanLetter,
    isLoadingFanLetter,
    isLoadingGenerate,
    isError,
    setIsError
  };
};
